import { CookieHelper } from "../../Common/CookieHelper";
import { GlobalData } from "../../Common/GlobalData";
import { Notification } from "../../Common/KendoHelpers";

export class WatchListSelector {
    private static readonly WATCHLIST_SELECTOR = '#watchListSelector';

    constructor() {
        this.create();
    }

    private create() {
        const self = this;

        const dataSource = new kendo.data.HierarchicalDataSource({
            transport: {
                read: {
                    url: GlobalData.URL_BASE + GlobalData.URL_SUFFIX_PORTFOLIO_WATCHLIST_MANAGER_WATCHLIST_SELECTOR,
                    dataType: "json",
                },
            },
            schema: {
                model: {
                    id: "watchListId",
                    hasChildren: "hasChildren",
                },
            },
            error: () => {
                const notification = new Notification();
                notification.error('No data found to display');
            },
        });

        // Use the correct type from @types/kendo-ui
        $(WatchListSelector.WATCHLIST_SELECTOR).kendoDropDownTree({
            placeholder: "Select WatchList...",
            height: 200,
            change: (e: kendo.ui.DropDownTreeChangeEvent) => {
                const widget = e.sender as kendo.ui.DropDownTree & { treeview?: kendo.ui.TreeView };

                // Try treeview first (typed). If not available, fallback to input DOM.
                const tree = widget.treeview as kendo.ui.TreeView | undefined;
                let label = "";

                if (tree && typeof tree.select === "function") {
                    const node = tree.select();
                    const dataItem = tree.dataItem(node) as any;
                    label = dataItem ? (dataItem.watchListName ?? dataItem.text ?? "") : "";
                } else {
                    // fallback: try the input text or .k-input
                    try {
                        if ((widget as any).input && typeof (widget as any).input.val === "function") {
                            label = String((widget as any).input.val() ?? "");
                        } else {
                            label = widget.element ? widget.element.find(".k-input").text().trim() : "";
                        }
                    } catch {
                        label = "";
                    }
                }

                self.onChange(widget.value(), label);
            },
            dataSource: dataSource,
            dataTextField: "watchListName",
            dataValueField: "watchListId",
        });
    }

    private onChange(watchListId: string, watchListName: string) {
        CookieHelper.set(GlobalData.WATCHLIST_MANAGER_WATCHLIST_ID_COOKIE, watchListId);
        CookieHelper.set(GlobalData.WATCHLIST_MANAGER_WATCHLIST_NAME_COOKIE, watchListName);
    }
}
